import { useState } from "react";
import { useNavigate } from "react-router";
import type { ActionFunctionArgs, LoaderFunctionArgs } from "react-router-dom";

import { CreateAccountPage } from "@src/deprecated/pages/CreateAccount";
import {
  authClient,
  resolvePostAuthDestination,
  waitForSession,
} from "@src/features/auth";
import { navigation } from "@src/shared/navigation";

export function meta() {
  return [
    { title: "Create Account" },
    { name: "description", content: "Create a new account" },
  ];
}

export function clientLoader(_: LoaderFunctionArgs) {
  return {};
}

export async function clientAction(_args: ActionFunctionArgs) {
  return {};
}

export default function CreateAccountForClient() {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  return (
    <CreateAccountPage
      onCancel={() => navigate(navigation.login())}
      onSubmit={async (values) => {
        try {
          const result = await authClient.signUp.email({
            ...values,
            email: values.email,
            name: `${values.firstName} ${values.lastName}`,
            password: values.password,
            type: "physician",
          });

          if (result.error) {
            setError(result.error.message ?? "An unknown error occurred");
            return;
          }

          // Better Auth's session store can briefly lag the just-set session
          // cookie. Wait for it before navigating so the post-signup route's
          // ActorProvider doesn't read a transient null session and bounce to
          // /login with a generic error (STITCH-426). On timeout, navigate
          // anyway — ActorProvider's bounded refetch is the safety net.
          await waitForSession();

          const destination = await resolvePostAuthDestination(
            navigation.dashboard(),
            { route: "create-account", operation: "postSignup" },
          );
          navigate(destination, { replace: true });
        } catch (error) {
          setError(
            error instanceof Error
              ? error.message
              : "An unexpected error occurred",
          );
        }
      }}
      error={error}
    />
  );
}
